import React from "react";
import WhatCoating from "./WhatCarDetailing";
import ContactUs from "../../homepage/contact-us/ContactUs";
import { Helmet } from "react-helmet";
import BenifitCarDetailing from "./BenifitCarDetailing";
import WeOfferSection from "./WeOfferSection";
import WhyWEChooseCardDetailing from "./WhyWEChooseCardDetailing";
import CarDetailingFaq from "./CarDetailingFaq";

const CarDetailingServicesDelhi = () => {
  return (
    <>
      <Helmet>
        <title>Top services for Car Detailing in Delhi with expert care</title>
        <meta
          name="description"
          content=" Get premium car detailing in Delhi with Caross. Our expert team provides thorough interior and exterior cleaning, ensuring it looks flawless. Schedule today!"
        />
        <script type="application/ld+json">
          {`{
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "How Long Does Ceramic Coating Last?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Our ceramic coatings typically last several years with proper care.",
                },
              },
              {
                "@type": "Question",
                name: "Can Ceramic Coating be Removed?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, but it requires professional removal.",
                },
              },
              {
                "@type": "Question",
                name: "Does Ceramic Coating Affect the Car's Appearance?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, it enhances the appearance with a deep, glossy finish.",
                },
              },
              {
                "@type": "Question",
                name: "Is Ceramic Coating Worth the Investment?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Absolutely, it offers long-term protection and enhances your car’s value.",
                },
              },
            ],
          }`}
        </script>
      </Helmet>
      <div className="p-2">
        <h1 className="text-center fw-bold" style={{ marginTop: "5rem" }}>
          Car Detailing <span style={{ color: "#b8242a" }}>  Services in Delhi </span>
        </h1>
        <WhatCoating />
        <BenifitCarDetailing />
        <WeOfferSection />
        <WhyWEChooseCardDetailing />
        <CarDetailingFaq />
        <ContactUs />
      </div>
    </>
  );
};

export default CarDetailingServicesDelhi;
